// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class WebSocketConstants {
	public static readonly CAUSED_BY_OPEN_HANDSHAKE_EVENT: string =
		'Open Handshake';
	public static readonly CAUSED_BY_ON_ERROR_EVENT: string = 'ErrorEvent';
}
